///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { SuiFileControlComponent } from '@siklu/sui-lib/infrastructure';
import { SuiTranslatePipe } from '@siklu/sui-lib/localization';

@Component({
    selector: 'winde-file-chooser',
    templateUrl: './sui-winde-file-chooser.component.html',
    styleUrls: ['./sui-winde-file-chooser.component.scss'],
    imports: [SuiTranslatePipe]
})
export class FileChooserComponent extends SuiFileControlComponent {
    @ViewChild('fileInput') input: ElementRef;
    @Input() accept = '*';
}
